import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Button,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Date, NameSurname } from "./contactlistCol";

import jsPDF from "jspdf";
import "jspdf-autotable";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';
import "jspdf-autotable";

import * as XLSX from 'xlsx';
import logo from '../../../assets/images/logo-dark.png'; // Logo dosyanızın doğru yolunu yazın

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import {
  getUsers as onGetUsers,
  addUser as onAddUser,
  updateUser as onUpdateUser,
  deleteUser as onDeleteUser,
} from "store/contacts/actions";
import { isEmpty } from "lodash";


//redux
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";

const ContactsList = props => {
  const tableRef = useRef(null);

  //meta title
  document.title = "Kullanıcı | Bee Education Admin PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();

const getLastSubscription = (user) => {
    // Backend'den gelen objede listenin adı 'IapSubscriptions' olmalı.
    // Eğer backend farklı bir isimle (örn: 'Subscriptions') dönüyorsa burayı değiştirin.
    if (!user.IapSubscriptions || user.IapSubscriptions.length === 0) return null;

    // Abonelikleri ExpiryTime'a göre sırala (Bitiş tarihi en ileri olan en üstte)
    const sortedSubs = [...user.IapSubscriptions].sort((a, b) => {
      return new Date(b.ExpiryTime) - new Date(a.ExpiryTime);
    });

    return sortedSubs[0]; // En güncel aboneliği döndür
  };
  
  // validation

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: (contactEdit && contactEdit.Users_NameSurname) || "",
      tel: (contactEdit && contactEdit.Users_TelephoneNumber) || "",
      password: (contactEdit && contactEdit.Users_LoginPasswordCode) || "",
      email: (contactEdit && contactEdit.MailAdress) || "",
      

    },
    validationSchema: Yup.object({
 
      username: Yup.string(3).required("Kullanıcı adı Giriniz"),

    }),

    onSubmit: values => {
      if (isEdit) {
        var localDate = moment().local();

        const updateUser = {
          ID: contactEdit.ID,
          Users_NameSurname: values.username,
          Users_TelephoneNumber: values.tel,
          Users_LoginPasswordCode: values.password,
        //  UsersPhoto:getFileName,
          Users_Type_ID: getCategoryID,
          MailAdress:values.email,
          Users_CreatedDateTime:localDate
        };
        dispatch(onUpdateUser(updateUser));
        setIsEdit(false);
        validation.resetForm();
      } else {
        console.log("lknskldşf",getCategoryID)
        var localDate = moment().local();

        const newUser = {
          Users_NameSurname: values["username"],
          Users_TelephoneNumber:values["tel"],
          MailAdress:values["email"],
          Users_LoginPasswordCode: values["password"],
        //  UsersPhoto:getFileName,
          Users_Type_ID: getCategoryID,
          Users_CreatedDateTime:localDate
        };
        // save new user
        dispatch(onAddUser(newUser));
        validation.resetForm();
      }
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.users,
  }));

  const [userList, setUserList] = useState([]);
  const [modal, setModal] = useState(false);
  const [modalMedia, setModalMedia] = useState(false);

  const [isEdit, setIsEdit] = useState(false);

  const [getCategoryID, setCategoryID] = useState(null);


  const [getCategory, setCategory] = useState([]);

  const onClickDelete = users => {
    setContact(users);
    setDeleteModal(true);
  };

  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => {
          return <input type="checkbox" className="form-check-input" />;
        },
      },
     
      {
        Header: "ID",
        accessor: "ID",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Adı",
        accessor: "Users_NameSurname",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

     {
        Header: "Üyelik Durumu",
        accessor: "MembershipStatus", 
        Cell: (cellProps) => {
          const lastSub = getLastSubscription(cellProps.row.original);
          
          // Mantık: Abonelik varsa VE Bitiş Tarihi (ExpiryTime) şu andan büyükse Premium'dur.
          const isPremium = lastSub && lastSub.ExpiryTime && new Date(lastSub.ExpiryTime) > new Date();

          return (
            <div className={`badge ${isPremium ? "bg-success" : "bg-secondary"} font-size-12`}>
              {isPremium ? "Premium" : "Free"}
            </div>
          );
        },
      },

      {
        Header: "Paket / Ürün",
        accessor: "ProductInfo",
        Cell: (cellProps) => {
            const lastSub = getLastSubscription(cellProps.row.original);
            if (!lastSub) return "-";
            
            // ProductId ve BasePlanId bilgisini göster (örn: premium_monthly / p1m)
            return (
              <div>
                <span className="d-block fw-bold">{lastSub.ProductId}</span>
                <span className="text-muted font-size-11">{lastSub.BasePlanId || ""}</span>
              </div>
            );
        }
      },

      {
        Header: "Durum Kodu",
        accessor: "State",
        Cell: (cellProps) => {
            const lastSub = getLastSubscription(cellProps.row.original);
            if (!lastSub) return "-";
            
            // State bilgisini (ACTIVE, PENDING vs.) gösterir
            return <span className="badge badge-soft-info font-size-11">{lastSub.State}</span>;
        }
      },

      {
        Header: "Başlangıç",
        accessor: "CreatedAt",
        Cell: cellProps => {
             const lastSub = getLastSubscription(cellProps.row.original);
             // Tablo: CreatedAt (Satın alma/oluşturma zamanı olarak kabul ediyoruz)
             if(!lastSub || !lastSub.CreatedAt) return "-";
             return <span>{moment(lastSub.CreatedAt).format('DD.MM.YYYY')}</span>;
        },
      },

      {
        Header: "Bitiş Tarihi",
        accessor: "ExpiryTime", 
        Cell: cellProps => {
             const lastSub = getLastSubscription(cellProps.row.original);
             // Tablo: ExpiryTime
             if(!lastSub || !lastSub.ExpiryTime) return "-";
             
             const isExpired = new Date(lastSub.ExpiryTime) < new Date();
             
             return (
                <span className={isExpired ? "text-danger" : "text-success fw-bold"}>
                    {moment(lastSub.ExpiryTime).format('DD.MM.YYYY HH:mm')}
                </span>
             );
        },
      },

      {
        Header: "Ücret",
        accessor: "PriceDisplay",
        Cell: cellProps => {
          const lastSub = getLastSubscription(cellProps.row.original);
          if (!lastSub) return "-";
          
          // 1. Seçenek: DisplayPrice varsa onu bas (Örn: ₺199,99)
          if (lastSub.DisplayPrice) {
            return <span className="fw-bold">{lastSub.DisplayPrice}</span>;
          }

          // 2. Seçenek: DisplayPrice yoksa PriceAmountMicros hesapla (Milyonda bir)
          if (lastSub.PriceAmountMicros) {
             const price = lastSub.PriceAmountMicros / 1000000;
             return (
               <span>
                 {price} {lastSub.PriceCurrencyCode}
               </span>
             );
          }
          
          return "-";
        },
      },
      {
        Header: "Kullanıcı Tipi",
        accessor: "Users_Type.Users_Type_Text",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      {
        Header: "Mail Adresi",
        accessor: "MailAdress",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },

      
      {
        Header: "Kayıt Tarihi",
        accessor: "Users_CreatedDateTime",
        filterable: true,
        Cell: cellProps => {
          return <Date {...cellProps} />;
        },
      },

      
      {
        Header: "Telefon Numarası",
        accessor: "Users_TelephoneNumber",
        filterable: true,
        Cell: cellProps => {
          return <NameSurname {...cellProps} />;
        },
      },
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              {/* PDF Butonları */}
              {cellProps.row.original.Plan != null && cellProps.row.original.Plan.length > 0 ? (
                <>
                  <Link to="#" className="text-success" onClick={() => handleUserClickPdfAll(cellProps.row.original)}>
                    <i className="mdi mdi-check-all font-size-18" id="pdftooltipall" />
                    <UncontrolledTooltip placement="top" target="pdftooltipall">Tüm PDF</UncontrolledTooltip>
                  </Link>
                  <Link to="#" className="text-success" onClick={() => handleUserClickPdf(cellProps.row.original)}>
                    <i className="mdi mdi-export font-size-18" id="pdftooltip" />
                    <UncontrolledTooltip placement="top" target="pdftooltip">Haftalık PDF</UncontrolledTooltip>
                  </Link>
                </>
              ) : null}

              {/* Düzenle */}
              <Link to="#" className="text-success" onClick={() => handleUserClick(cellProps.row.original)}>
                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                <UncontrolledTooltip placement="top" target="edittooltip">Düzenle</UncontrolledTooltip>
              </Link>
              
              {/* Sil */}
              <Link to="#" className="text-danger" onClick={() => onClickDelete(cellProps.row.original)}>
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">Sil</UncontrolledTooltip>
              </Link>
            </div>
          );
        },
      },
    ],
    []
  );


  // PDF Oluşturma ve İndirme Fonksiyonu
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4"; // Veya "A3"
    const orientation = "landscape"; // Tablo geniş olduğu için yatay (landscape) daha iyi olur

    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    doc.text("Kullanıcı ve Abonelik Listesi", 40, 40);

    // Tablo Başlıkları
    const headers = [[
      "Kullanıcı Adı",
      "Telefon",
      "Email",
      "Durum",
      "Platform",
      "Ürün/Paket",
      "Başlangıç",
      "Bitiş",
      "Ücret"
    ]];

    // Verileri Hazırlama
    const data = users.map(user => {
      // Mevcut yardımcı fonksiyonunuzu kullanarak en güncel aboneliği alıyoruz
      const lastSub = getLastSubscription(user);
      
      // Premium kontrolü
      const isPremium = lastSub && lastSub.ExpiryTime && new Date(lastSub.ExpiryTime) > new Date();
      
      // Fiyat Formatlama (Tablodaki mantığın aynısı)
      let priceText = "-";
      if (lastSub) {
         if (lastSub.DisplayPrice) {
            priceText = lastSub.DisplayPrice;
         } else if (lastSub.PriceAmountMicros) {
            priceText = (lastSub.PriceAmountMicros / 1000000) + " " + (lastSub.PriceCurrencyCode || "");
         } else if (lastSub.Price) {
            priceText = lastSub.Price + " " + (lastSub.Currency || "");
         }
      }

      return [
        user.Users_NameSurname || "-",
        user.Users_TelephoneNumber || "-",
        user.MailAdress || "-",
        isPremium ? "Premium" : "Free", // Durum
        lastSub ? lastSub.Platform : "-", // Platform (iOS/Android)
        lastSub ? (lastSub.ProductId || "-") : "-", // Paket Adı
        lastSub && lastSub.CreatedAt ? moment(lastSub.CreatedAt).format('DD.MM.YYYY') : "-", // Başlangıç
        lastSub && lastSub.ExpiryTime ? moment(lastSub.ExpiryTime).format('DD.MM.YYYY') : "-", // Bitiş
        priceText // Ücret
      ];
    });

    // Tabloyu Oluştur
    doc.autoTable({
      startY: 50,
      head: headers,
      body: data,
      theme: 'grid',
      styles: {
        fontSize: 10,
        cellPadding: 3,
      },
      headStyles: {
        fillColor: [22, 160, 133], // İsterseniz başlık rengini değiştirebilirsiniz
        textColor: 255
      }
    });

    doc.save("Tum_Kullanicilar_ve_Abonelikler.pdf");
  };

  const _getAuthData = async () => {

    await axios.get(`https://beeducationadmin.stechomeyazilim.info:8093/getUsersType/select/`)
      .then((res) => {
        setCategory(res.data)
      })
  }

  useEffect(() => {
    _getAuthData()
    if (users && !users.length) {
      dispatch(onGetUsers());
      setIsEdit(false);
    }
  }, [dispatch, users]);

  useEffect(() => {
    setContact(users);
    // setIsEdit(false);
  }, [users]);

  useEffect(() => {
    if (!isEmpty(users) && !!isEdit) {
      setContact(users);
      //setIsEdit(false);
    }
  }, [users]);

  const toggle = () => {
    setModal(!modal);
  };

  const toggleMedia = () => {
    setModalMedia(!modalMedia);
  };



  
  const toBase64 = async (url) => {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleString(); // Yerel tarih ve saat formatı
};


  const handleUserClickPdf = async(arg) => {
    try {

      const userData = arg;


      const base64Logo = await toBase64(logo);
            const workbook = new ExcelJS.Workbook();
            const userSheet = workbook.addWorksheet('Kullanıcı Bilgileri');
            const planSheet = workbook.addWorksheet('Ders Planları');

            // Kullanıcı bilgilerini ekleme
            userSheet.addRow(['Kullanıcı Adı', userData.Users_NameSurname]);
            userSheet.addRow(['Telefon Numarası', userData.Users_TelephoneNumber]);
            userSheet.addRow(['Email', userData.MailAdress]);

            // Logoyu ekleme
            const imageId = workbook.addImage({
                base64: base64Logo,
                extension: 'png',
            });

            userSheet.addImage(imageId, {
                tl: { col: 1, row: 6 },
                ext: { width: 350, height: 200 },
            });

            // Bir haftalık planları filtreleme
            const oneWeekFromNow = new window.Date();
            oneWeekFromNow.setDate(oneWeekFromNow.getDate() + 7);

            const filteredPlans = userData.Plan.filter(plan => {
                const planStartDate = new window.Date(plan.StartDateTime);
                return !isNaN(planStartDate) && planStartDate >= new window.Date() && planStartDate <= oneWeekFromNow;
            });

            // Ders planlarını ekleme
            planSheet.addRow([
                'Başlangıç Zamanı',
                'Bitiş Zamanı',
                'Soru Sayısı',
                'Plan Kategorisi',
                'Plan Aktivitesi',
                'Kitap Başlığı',
                "AltBaşlık",
                "Konu",
                "Ders"

            ]);

            if (filteredPlans.length > 0) {
                filteredPlans.forEach(plan => {
                    planSheet.addRow([
                        moment(plan.StartDateTime).format('DD/MM/YYYY'), 
                        moment(plan.FinishDateTime).format('DD/MM/YYYY'), 
                        plan.NumberOfQuestions || 'Belirtilmemiş',
                        plan.Plan_Category,
                        plan.Plan_Activity || 'Yok',
                        plan.Plan_BookTitle || 'Belirtilmemiş',
                        plan.Book_SubSubject.Book_SubSubject_Title,
                        plan.Book_SubSubject.Book_Subject.Book_Subject_Title,
                        plan.Book_SubSubject.Book_Subject.Lesson.Lesson_Title
                    ]);
                });
            } else {
                planSheet.addRow(['Ders Planı Bulunamadı']);
            }

            // Excel dosyasını oluştur ve indir
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, userData.Users_NameSurname + ' KullaniciBilgileri_DersPlanlari.xlsx');
  } catch (error) {
      console.error('Error exporting to Excel:', error);
  }
  };

  const handleUserClickPdfAll = async(arg) => {
    try {

      const userData = arg;


      const base64Logo = await toBase64(logo);
            const workbook = new ExcelJS.Workbook();
            const userSheet = workbook.addWorksheet('Kullanıcı Bilgileri');
            const planSheet = workbook.addWorksheet('Ders Planları');

            // Kullanıcı bilgilerini ekleme
            userSheet.addRow(['Kullanıcı Adı', userData.Users_NameSurname]);
            userSheet.addRow(['Telefon Numarası', userData.Users_TelephoneNumber]);
            userSheet.addRow(['Email', userData.MailAdress]);

            // Logoyu ekleme
            const imageId = workbook.addImage({
                base64: base64Logo,
                extension: 'png',
            });

            userSheet.addImage(imageId, {
                tl: { col: 1, row: 6 },
                ext: { width: 350, height: 200 },
            });


            // Ders planlarını ekleme
            planSheet.addRow([
                'Başlangıç Zamanı',
                'Bitiş Zamanı',
                'Soru Sayısı',
                'Plan Kategorisi',
                'Plan Aktivitesi',
                'Kitap Başlığı',
                "AltBaşlık",
                "Konu",
                "Ders"

            ]);

            if (userData.Plan.length > 0) {
              userData.Plan.forEach(plan => {
                    planSheet.addRow([
                        moment(plan.StartDateTime).format('DD/MM/YYYY'), 
                        moment(plan.FinishDateTime).format('DD/MM/YYYY'), 
                        plan.NumberOfQuestions || 'Belirtilmemiş',
                        plan.Plan_Category,
                        plan.Plan_Activity || 'Yok',
                        plan.Plan_BookTitle || 'Belirtilmemiş',
                        plan.Book_SubSubject.Book_SubSubject_Title,
                        plan.Book_SubSubject.Book_Subject.Book_Subject_Title,
                        plan.Book_SubSubject.Book_Subject.Lesson.Lesson_Title
                    ]);
                });
            } else {
                planSheet.addRow(['Ders Planı Bulunamadı']);
            }

            // Excel dosyasını oluştur ve indir
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'KullaniciBilgileri_DersPlanlari.xlsx');
  } catch (error) {
      console.error('Error exporting to Excel:', error);
  }
  };
  const handleUserClick = (arg) => {
    const user = arg;

    setEditContact(user);

    setCategoryID(user.Users_Type_ID)


    setIsEdit(true);


    toggle();
  };


  var node = useRef();
  const onPaginationPageChange = page => {
    if (
      node &&
      node.current &&
      node.current.props &&
      node.current.props.pagination &&
      node.current.props.pagination.options
    ) {
      node.current.props.pagination.options.onPageChange(page);
    }
  };

  //delete customer
  const [deleteModal, setDeleteModal] = useState(false);



  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteUser(contact.ID));
    }
    onPaginationPageChange(1);
    setDeleteModal(false);
  };

  const handleUserClicks = () => {
    setUserList("");
    setIsEdit(false);
    toggle();
  };

  const _setChoiceCategory = arg => {
    setCategoryID(arg.target.value)
  }

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };


  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Yönetim" breadcrumbItem="Kullanıcı Listesi" />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>

                  <div className="d-flex justify-content-end mb-3 gap-2">
      <Button 
        color="danger" 
        className="btn-rounded" 
        onClick={exportPDF}
      >
        <i className="mdi mdi-file-pdf-box me-1"></i> PDF İndir (Tüm Liste)
      </Button>
  </div>

                  <TableContainer
                    columns={columns}
                    data={users}
                    ref={tableRef}
                    isGlobalFilter={true}
                    isAddForumList={true}
                    handleOrderClicks={handleUserClicks}
                    customPageSize={10}
                    className="custom-header-css"
                  />
                

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      {!!isEdit ? "Düzenle" : "Kullanıcı Ekle"}
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <Row>
                          <Col xs={12}>



                            <div className="mb-3">
                              <Label className="form-label">Kullanıcı Adı</Label>
                              <Input
                                name="username"
                                label="username"
                                type="text"
                                placeholder="Kullanıcı Adını Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.username || ""}
                                invalid={
                                  validation.touched.username &&
                                    validation.errors.username
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.username &&
                                validation.errors.username ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.username}
                                </FormFeedback>
                              ) : null}
                            </div>



                            <div className="mb-3">
                              <Label className="form-label">Email Adresi</Label>
                              <Input
                                name="email"
                                label="email"
                                type="text"
                                placeholder="Email Adresi Giriniz"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                    validation.errors.email
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.email &&
                                validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.email}
                                </FormFeedback>
                              ) : null}
                            </div>

                          
                            <div className="mb-3">
                              <Label className="form-label">Kullanıcı Tipi Seçiniz</Label>
                              <Input
                                name="paymentStatus"
                                type="select"
                                className="form-select"
                                defaultValue={getCategoryID}
                                onChange={(text) => _setChoiceCategory(text)}
                                value={
                                  getCategoryID
                                }>
                               <option value="">Lütfen Seçim Yapınız</option>


                                {getCategory.map((item, index) => (
                                  <option value={item.ID} key={item.ID}>{item.Users_Type_Text}</option>
                                ))}

                              </Input>
                              {validation.touched.wsText && validation.errors.wsText ? (
                                <FormFeedback type="invalid">{validation.errors.wsText}</FormFeedback>
                              ) : null}
                            </div>

                            <div className="mb-3">
                              <Label className="form-label">Kullanıcı Şifre</Label>
                              <div style={{ display: "flex", alignItems: "center" }}>

                              <Input
                                name="password"
                                label="password"
                                type="text"
                                placeholder="Kullanıcı Şifresi"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.password || ""}
                                invalid={
                                  validation.touched.password &&
                                    validation.errors.password
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.password &&
                                validation.errors.password ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.password}
                                </FormFeedback>
                              ) : null}
                                 <Button
          type="button"
          onClick={togglePasswordVisibility}
          style={{ marginLeft: "10px" }}
        >
          {showPassword ? "Gizle" : "Göster"}
        </Button>
        </div>

                            </div>


                            <div className="mb-3">
                              <Label className="form-label">Kullanıcı Telefon</Label>
                              <Input
                                name="tel"
                                label="tel"
                                type="text"
                                placeholder="Kullanıcı Telefon"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.tel || ""}
                                invalid={
                                  validation.touched.tel &&
                                    validation.errors.tel
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.tel &&
                                validation.errors.tel ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.tel}
                                </FormFeedback>
                              ) : null}
                            </div>
                           

                       
                          </Col>
                        </Row>
                        <Row>



                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                              >
                                Kaydet
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
